// extracted by mini-css-extract-plugin
module.exports = {"heading":"Header_heading__1zOTx","subHeading":"Header_subHeading__XjQ2S","text":"Header_text__2jFmL","container":"Header_container__-DA3E","mobileNav":"Header_mobileNav__2_aLF"};